export const PDF_CAR_SEPARATOR = "|" as const;
